// extracted by mini-css-extract-plugin
export default {"markdown":"releaseLog_markdown__Ds6Th"};